/* AF-LIB HELPERS */
import { localStorageHelpers } from '@af-lib/ui-lib';

import ViktorClient from '@/api/clients/viktorClient/ViktorClient';

/**
 * Perform a login in dev mode, and store the viktor tokens
 *
 * @param {Object} options : user's credentials
 * {
 *      email: {String},
 *      password: {String}
 * }
 */
export function login(options) {
  const { email, password, oauth_token } = options;

  return new Promise<void>((resolve, reject) => {
    if (process.env.NODE_ENV === 'development') {
      if (password) {
        ViktorClient()
          .post('/auth/sign-in', { email, password })
          .then(() => {
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      } else {
        // Check if a dev account has been set by the NavBarDevMenu.
        // If yes, connect to it
        const devAccount = localStorageHelpers.getLocalItem('dev_account');

        ViktorClient()
          .post('/auth/oauth', { email: devAccount ?? email, token: oauth_token })
          .then(() => {
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      }
    } else {
      resolve();
    }
  });
}
/**
 * Perform a logout
 */
export function logout() {
  return new Promise<void>((resolve, reject) => {
    ViktorClient()
      .post('/auth/logout')
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}
